
























import Vue from 'vue';
import { Component, Prop, Watch, Model } from 'vue-property-decorator';
import { env } from '@/env';
import translationsService from '@/services/translations';
import httpClient from '@/core/http/http-client';
import '@sgs/file-preview-hocr-client-js';

declare const Util: any;

@Component({
  name: 'FilePreviewHocr',
  components: {}
})
export default class FilePreviewHocrComponent extends Vue {
  @Prop()
  public documentId!: string;

  public async previewHocr(documentId: string, target: string) {
    const downloadUrl = translationsService.getDownloadUrl(documentId, target);
    const scopes = httpClient.authContext.getScopesForEndpoint(downloadUrl);
    const token = httpClient.authContext.getCachedTokenInternal(scopes, httpClient.authContext.getAccount(), '').accessToken;
    await Util.init(downloadUrl, `Bearer ${token}`);
  }
}
